import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ApiResource } from '../../resources/api.resource';
import { Router} from '@angular/router';



declare var $:any;

@Component({
  selector: 'buscar-component',
  templateUrl: './buscar.component.html',
  styleUrls: ['./buscar.component.scss']
})
export class BuscarComponent implements OnInit {

  public inputBuscar = '';
  public responseBuscar = [];
  public filtro = [];
  public componenteAct='';

  @Output() uuid: EventEmitter<any> = new EventEmitter();
  @Output() padre: EventEmitter<any> = new EventEmitter();


  constructor(private apiResource: ApiResource,private route: Router) { }

  ngOnInit() {
   
    this.componenteAct=localStorage.getItem("componenteActual")
     console.log('componenteActual---> buscar--->'+ this.componenteAct)
     this.buscar('');
    
   $("body").css("overflow", "scroll");
   $("#lg_slide").removeClass("active");
   
   
  }

  public buscar(name) {

    this.responseBuscar = []; 

    try {
      this.apiResource.buscar(this.inputBuscar).subscribe(resp => {
        if (resp.response != null) {
          this.responseBuscar = resp.response;
          this.filtro = resp.response;
        }
        else {
          this.responseBuscar = [];
          this.filtro=[];
        }
      });
    } catch (error) {
      this.responseBuscar = [];
    }

  }

  filtrar(filter: string){
      if(!this.responseBuscar || !filter) {
          this.filtro = this.responseBuscar;
      }
      this.filtro = this.responseBuscar.filter(item => JSON.stringify(item).toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  redireccionarAPaginaExistente(uuid, padre){
    
    console.log('buscar uuid--->'+uuid);
    console.log('buscar padre--->'+padre);


    this.uuid.emit(uuid);
    localStorage.setItem("uuidBuscar",uuid);

       
   // $(".lg-menu").fadeOut();
  }

  redireccionarAPaginaExistente2(uuid, padre){
    
    console.log('Buscar--->localstorage----->uuid: '+uuid+'   padre:'+padre);
    
    localStorage.setItem("uuidBuscar",uuid);
    localStorage.setItem("buscarHacia",padre);

       
   // $(".lg-menu").fadeOut();
  }



}
